import { httpGet, httpPost, httpPostRaw } from "@eres/rest";
import { I8N } from "@eres/core";
import cfg from "./config";
import { ValidationError } from "./entities";

export interface TRResponse<T> {
	Code: number | string;
	Message: string;
	Response: T;
}

export function validatePropertyOwner( request: any ) {
	return httpPost( cfg.ownerCommitteeAPI().endPoint() + "owner/validate", request );
}

export function registerBoardMember( request: any ) {
	return httpPost( cfg.ownerCommitteeAPI().endPoint() + "owner/register", request );
}

export function getLookUp( lookupName: string ) {
	return httpGet( cfg.ownerCommitteeAPI().endPoint() + "lookup/" + lookupName );
}

export function getRequestList( ownerNumber: any ) {
	return httpGet( cfg.ownerCommitteeAPI().endPoint() + "owner/status/" + ownerNumber + "/list" );
}

export function uploadDocument( file: File, propertyId: number, ownerNumber: number, documentId?: number ) {
	const data = new FormData();
	data.append( "document", file, file.name );
	return httpPostRaw( cfg.ownerCommitteeAPI().endPoint() + "owner/register/file/" + propertyId + "/" + ownerNumber + "/" + documentId, data );
}

export function validateResponse<T>( response: TRResponse<T> ): Promise<T> {
	if ( response ) {
		if ( response.Code === 0 || response.Code === "0" ) {
			return Promise.resolve( response.Response );
		} else {
			return Promise.reject( response.Message );
		}
	} else {
		return Promise.reject( "Invalid Response" );
	}
}

export function getValidationError( errors: ValidationError[] ) {
	let errorMsg = errors.map( ( error: ValidationError ) => {
		if ( error.errorMessage ) {
			return error.errorMessage;
		} else {
			return I8N.locale() === "ar" ? error.nameAr : error.nameEn;
		}
	} );
	return errorMsg.join( "\n" );
}

export function checkErrors( response: any ): Promise<any> {
	if ( response ) {
		if ( response.response != undefined && ( response.responseCode + "" === "Success" ) ) {
			return response.response;
		} else if ( response.responseCode + "" === "Error" ) {
			return response;
		} else if ( response.responseCode + "" === "Empty" ) {
			return response;
		} else if ( response.hasOwnProperty( "validationErrorsList" ) ) {
			let errors = response.validationErrorsList;
			if ( errors != undefined ) {
				if ( Array.isArray( errors ) && errors.length > 0 ) {
					let errorMessage = response.validationErrorsList.map( ( error: any ) => {
						return error.errorMessage + "\n";
					} );
					return Promise.reject( errorMessage );
				}
			}
		} else if ( response.hasOwnProperty( "errorList" ) ) {
			let errors = response.errorList;
			if ( errors != undefined ) {
				if ( Array.isArray( errors ) && errors.length > 0 ) {
					let errorMessage = response.errorList.map( ( error: any ) => {
						return I8N.locale() === "ar" ? error.nameAr : error.nameEn;
					} );
					return Promise.reject( errorMessage );
				}
			}
		} else {
			if ( response.Message != undefined ) {
				return Promise.reject( response.Message );
			} else {
				return Promise.reject( "Error " + response.Code );
			}
		}
	}
	return response;
}

export function checkValidationErrorWithMessage( response: any, key: string = "errorList" ): Promise<any> {
	if ( response ) {
		if ( response.hasOwnProperty( key ) && !response.isValid ) {
			let errors = response[ key ];
			if ( errors != undefined ) {
				if ( Array.isArray( errors ) && errors.length > 0 ) {
					let errorMessage = response.errorList.map( ( error: any ) => {
						return I8N.locale() === "ar" ? error.nameAr : error.nameEn;
					} );
					return Promise.reject( errorMessage );
				}
			}
		}
	}
	return response;
}
